import { useSiteContent } from "@/lib/siteContent";

export default function ProblemSolution() {
  const sc = useSiteContent();
  return (
    <section data-testid="problem-solution-section" className="relative py-24 lg:py-32 border-t border-[var(--line)]">
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="eyebrow mb-5">The Reason You&apos;re Here</div>
            <h2 className="font-display text-[44px] sm:text-5xl lg:text-[72px] leading-[1.02] tracking-[-0.035em] text-ink" data-testid="problem-headline">
              {sc.problem_headline}
            </h2>

            <div
              className="mt-10 space-y-6 max-w-2xl text-[17px] leading-[1.75] text-ink/75 problem-statement-body"
              data-testid="problem-statement-body"
              dangerouslySetInnerHTML={{ __html: sc.problem_statement_html }}
            />
          </div>

          <div className="lg:col-span-5 lg:pl-10 lg:border-l lg:border-[var(--line)] lg:pt-2">
            <div className="sticky top-32 space-y-10">
              <Stat label="Avg dev quote for a small business site" value="$8,500+" />
              <Stat label="Avg time waiting on first draft" value="6 weeks" />
              <Stat label="Time it takes you in this lab" value={sc.lab_duration_label} highlight />
            </div>
          </div>
        </div>

        <div className="mt-20 max-w-4xl">
          <p className="font-display text-2xl sm:text-3xl lg:text-[42px] text-ink leading-[1.15] tracking-[-0.025em]">
            AI is not replacing your{" "}
            <span className="font-serif-em italic text-brand font-light">vision.</span>
            <br />
            It&apos;s helping you{" "}
            <span className="font-serif-em italic text-brand font-light">move faster.</span>
          </p>
        </div>
      </div>
    </section>
  );
}

function Stat({ label, value, highlight }) {
  return (
    <div data-testid="problem-stat">
      <div className={`pl-5 ${highlight ? "border-l-2 border-brand" : "border-l border-[var(--line)]"}`}>
        <div className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[var(--muted)]">{label}</div>
        <div className={`font-display text-4xl sm:text-5xl tracking-[-0.03em] mt-2 ${highlight ? "text-brand" : "text-ink"}`}>
          {value}
        </div>
      </div>
    </div>
  );
}
